import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { IDTypeRequest } from 'civil-status/constants/id-type-request';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

const typesData: Array<ItemVM> = [
  {
    id: IDTypeRequest.Scritta,
    value: 'Scritta',
  },
  {
    id: IDTypeRequest.Verbale,
    value: 'Verbale',
  },
];

interface ListTypeRequestProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (value: SelectChangeEvent<string>) => void;
  error?: boolean;
  isSmallSize?: boolean;
}

const ListTypeRequestComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  isSmallSize = false,
}: ListTypeRequestProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="type-label">
        {required ? 'Tipo richiesta *' : 'Tipo richiesta'}
      </InputLabel>
      <PmiSelect
        labelId="type-label"
        id="type"
        name="type"
        value={value}
        label={required ? 'Tipo richiesta *' : 'Tipo richiesta'}
        onChange={onChange}
        disabled={disabled}
        error={error}
        size={isSmallSize ? 'small' : undefined}
      >
        {typesData?.map((type: ItemVM) => (
          <MenuItem key={type.id} value={type.id}>
            {type.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListTypeRequestComponent.displayName = 'List type component';

const ListTypeRequest = memo(ListTypeRequestComponent);

export default ListTypeRequest as typeof ListTypeRequestComponent;
